module.exports = __webpack_public_path__ + "static/media/adownarrow.b5e95432.svg";